import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { AppThunk, RootState } from '../../store';

const exchangesSlice = createSlice({
  name: 'exchanges',
  initialState: [
    {
      name: 'cash',
      active: false,
    },
    {
      name: 'gemini',
      active: false,
    },
    {
      name: 'coinbase',
      active: false,
    },
    {
      name: 'blockfi',
      active: false,
    },
    {
      name: 'kraken',
      active: false,
    },
    {
      name: 'river',
      active: false,
    },
    {
      name: 'abra',
      active: false,
    },
  ],
  reducers: {
    toggleActive: (state, action) => {
      const { name } = action.payload;
      const exchange = state.find((el) => el.name === name);
      exchange.active = !exchange.active;
    },
    resetExchanges: (state) => {
      state.forEach((exchange: { active: boolean }) => {
        exchange.active = false;
      });
    },
  },
});

export const { toggleActive, resetExchanges } = exchangesSlice.actions;

export default exchangesSlice.reducer;

export const selectCurrent = (state: RootState) => state.exchanges;

